import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclSideNavItem,
    CclMessageService,
    CclDrawerService,
    CclPopupService
} from "certain-common-library";
import { SharedService } from "../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../modules/shared/services/catalog.service";
import { SessionService } from "../../../modules/shared/services/session-service";
import { Subscription } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { AttendeeSessionService } from "../../../modules/shared/services/attendee-session.service";
import { LocalDataService } from "../../../modules/shared/services/local-data.service";
import { cloneDeep } from "lodash";
import { CookieService } from "ngx-cookie";
import { FlashMessagesService } from "angular2-flash-messages";
import * as mustache from "mustache";
import { DatePipe } from "@angular/common";
@Component({
    selector: "app-item-context",
    templateUrl: "./catalog-context.view.html",
    styleUrls: []
})
export class CatalogContextView implements OnInit, AfterViewInit, OnDestroy {
    subscription: Subscription;
    headerConfig: any;
    headerConfigObj: any;
    htmlTopConfig: any;
    htmlTopConfigObj: any;
    htmlBottomConfig: any;
    htmlBottomConfigObj: any;
    footerConfig: any;
    footerConfigObj: any;
    drawerControlConfig: any;
    tabConfig;
    additionalSetting;
    jsonConfig;
    loginConfig;
    filterConfig;
    toggleProfileDropdown: any = false;
    timezone: any;
    private tracks: any;
    mysessionConfig: any = {}
    ddfData:any = {};
    generalDataConfig:any;
    token: string = '';
    showTabSection = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private messageService: CclMessageService,
        private catalogService: CatalogService,
        private sessionService: SessionService,
        private sanitizer: DomSanitizer,
        private drawerService: CclDrawerService,
        private popupService: CclPopupService,
        private attendeeSessionService: AttendeeSessionService,
        private localDataService: LocalDataService,
        private cookieService: CookieService,
        private _flashMessagesService: FlashMessagesService,
        private route: ActivatedRoute,
        private datePipe: DatePipe
    ) {

        if (this.cookieService.get("catalog_" + this.sharedService.setup.id) != undefined) {
            var cookie = JSON.parse(this.cookieService.get("catalog_" + this.sharedService.setup.id));
            this.showHtmlTop = cookie.showHtmlTop;
        }

        this.route.queryParams.subscribe(params => {
            if(params['key']) {
                this.token = params['key'];
            }
        });

        this.navSecondaryService.includeSave = false;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.changeContext(message));
        this.tabConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG].config);
    }

    ngOnInit() {
        this.sharedService.loggedInAttendee = JSON.parse(sessionStorage.getItem("loggedInAttendee_" + this.sharedService.eventUUID));
        document.title = "Session Catalog - " + this.sharedService.setup.catalogName;
        if (!this.sharedService.isEmptyString(this.sharedService.errorStr)) {
            this._flashMessagesService.show(this.sharedService.errorStr, {
                cssClass: "alert-danger"
            });
        }
        this.generalDataConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
        );
        this.jsonConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.headerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.HEADER_FOOTER.header].config
        );
        this.headerConfigObj = cloneDeep(this.headerConfig);
        this.footerConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.HEADER_FOOTER.footer].config
        );
        this.footerConfigObj = cloneDeep(this.footerConfig);
        this.htmlTopConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.HTML.top].config);
        this.htmlTopConfigObj = cloneDeep(this.htmlTopConfig);
        this.htmlBottomConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.HTML.bottom].config
        );
        this.htmlBottomConfigObj = cloneDeep(this.htmlBottomConfig);
        this.additionalSetting = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.ADDITIONAL_SETTING_CONFIG].config
        );
        this.drawerControlConfig = JSON.parse(
            this.sharedService.configs[this.sharedService.configTypes.MYSESSION].config
        ).drawer_button;
        this.loginConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config);
        if(this.sharedService.configs[this.sharedService.configTypes.MYSESSION]) {
        this.mysessionConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.MYSESSION].config);
        }
        if (!this.loginConfig.hasOwnProperty("isEnabled")) {
            this.loginConfig["isEnabled"] = true;
        }
        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );
        }

        const headFragment = document.createRange().createContextualFragment(this.additionalSetting.header);
        const footFragment = document.createRange().createContextualFragment(this.additionalSetting.footer);
        $(headFragment).insertAfter("div .attendee-header");
        document.getElementsByTagName("body")[0].appendChild(footFragment);
    }

    ngAfterViewInit(): void {
        let eventDetail = cloneDeep(this.sharedService.event)
        eventDetail.strStartDate = this.datePipe.transform(
            eventDetail.strStartDate.replace(new RegExp(" ", "g"), "T"),
            this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat
        );
        eventDetail.strEndDate = this.datePipe.transform(
            eventDetail.strEndDate.replace(new RegExp(" ", "g"), "T"),
            this.generalDataConfig.dateTimeFormats.dateFormat +
                "," +
                this.generalDataConfig.dateTimeFormats.timeFormat
        );
        
        this.ddfData = { 
            event: eventDetail , 
            registrations: this.sharedService.loggedInAttendee
        };
        this.addDdfs();
        if(this.token) {
            this.validateToken();
        }
    }

    validateToken() {
        this.attendeeSessionService.validatetoken({'urlKey': this.token, 'eventId': this.sharedService.event.id}).subscribe((response) => {
            this.popupService.hidePopup();
            this.sharedService.resetPasswordDetails = response['body']['registrationUserForgotPasswordDTO'];
            setTimeout(() => {
                this.openForgotPasswordPopUp('resetPassword');
            }, 1000);
        },
        (err) => {
            var message = "";
            if (err.error.errorResponse != null && err.error.errorResponse.errors != null) {
                err.error.errorResponse.errors.forEach((element) => {
                    message += element + "\n";
                });
            }

            this._flashMessagesService.show(message, {
                cssClass: "alert-danger"
            });
        })
    }

    openForgotPasswordPopUp(item) {
        let url = "";
        if (item == "resetPassword") {
            this.popupService.setPosition("center");
            this.popupService.setHeight("50%");
            this.popupService.setSize("small");
            this.popupService.togglePopup();
            this.sharedService.currentPopup = {
                title: null,
                navLinks: null,
                saveMessage: "resetPassword",
                showFooter: false
            };
            url = "popup/resetPassword";
        }
        this.sharedService.navigateToOutlet("popup", url);
    }

    addDdfs() {
        this.htmlTopConfig.template.pages['landing'].content.children.forEach(element => {
            this.renderTemplates(element);
        });
        this.headerConfig.template.pages['landing'].content.children.forEach(element => {
            this.renderTemplates(element);
        });
        this.htmlBottomConfig.template.pages['landing'].content.children.forEach(element => {
            this.renderTemplates(element);
        });
        this.footerConfig.template.pages['landing'].content.children.forEach(element => {
            this.renderTemplates(element);
        });
        this.cdr.detectChanges();
    }

    renderTemplates(element) {
        element.forEach(elem => {
            if (elem.content.type == "image") {
                elem.content.overlayText = mustache.render(elem.content.overlayText, this.ddfData); 
            } else if(elem.content.type == "text") {
                elem.content.content = mustache.render(elem.content.content, this.ddfData); 
            }
        });
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    changeContext(message) {
        if (message.text == "update-context") {
            this.navSecondaryService.contextLabel =
                message.data.account.name + " - " + message.data.event.name + " - " + message.data.catalog.catalogName;
        } else if (message.text == "use-default") {
            this.openPopup(message.data.popupName, null);
        } else if (message.text == "toggle-cart") {
            this.toggleCart();
        } else if (message.text == "toggle-myschedule") {
            this.toggleMySchedule();
        } else if (message.text == "toggle-instances") {
            this.toggleSessionInstances();
        } else if (message.text == "attendee-deleted") {
            this.logout();
        } else if (message.text == "close-cart-if-open") {
            if (this.showCart) {
                this.showCart = false;
            }
        } else if (message.text == "close-myschedule-if-open") {
            if (this.showMySchedule) {
                this.showMySchedule = false;
            }
        } else if (message.text == "attendee-logout") {
            this.ddfData = { 
                event: this.sharedService.event , 
                registrations: ''
            };
            this.headerConfig = cloneDeep(this.headerConfigObj);
            this.footerConfig = cloneDeep(this.footerConfigObj);
            this.htmlTopConfig = cloneDeep(this.htmlTopConfigObj);
            this.htmlBottomConfig = cloneDeep(this.htmlBottomConfigObj);

            this.addDdfs();
        } else if(message.text == "attendee-login" || message.text == "loggedIn") {
            this.ddfData = { 
                event: this.sharedService.event , 
                registrations: this.sharedService.loggedInAttendee
            };
            this.headerConfig = cloneDeep(this.headerConfigObj);
            this.footerConfig = cloneDeep(this.footerConfigObj);
            this.htmlTopConfig = cloneDeep(this.htmlTopConfigObj);
            this.htmlBottomConfig = cloneDeep(this.htmlBottomConfigObj);
            this.addDdfs();
        } else if(message.text == "show-tab-on date-load") {
            this.showTabSection = true;
        }
    }

    openPopup(item, $event) {
        if ($event != null) {
            $event.stopPropagation();
        }
        let url = "";
        if (item == "login") {
            this.popupService.setPosition("center");
            this.popupService.setHeight("50%");
            this.popupService.setSize("small");
            this.popupService.togglePopup();
            this.sharedService.currentPopup = {
                title: null,
                navLinks: null,
                saveMessage: "reg-login",
                showFooter: false
            };
            url = "popup/login";
        }
        this.sharedService.navigateToOutlet("popup", url);
    }

    openDrawer(item, $event) {
        if ($event != null) {
            $event.stopPropagation();
        }
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "cart") {
            this.sharedService.currentDrawer = {
                title: "<i role=\"presentation\" class='fa fa-cube fa-lg'></i> My Sessions",
                navLinks: null,
                saveMessage: null
            };
            url = "config-drawer/cart";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    logout() {
        if (this.sharedService.loggedInAttendee != null) {
            this.attendeeSessionService.logout(this.sharedService.loggedInAttendee.uuid).subscribe((resp) => {
                this.sharedService.loggedInAttendee = null;
                this.sharedService.regUUID = null;
                sessionStorage.setItem(
                    "loggedInAttendee_" + this.sharedService.eventUUID,
                    this.sharedService.loggedInAttendee
                );
                sessionStorage.setItem("regUUID_" + this.sharedService.eventUUID, this.sharedService.regUUID);
                // keeping older cookies removal for fail safe
                this.cookieService.remove("attendeeId_" + this.sharedService.setup.id);
                this.cookieService.remove("attendeeUUID_" + this.sharedService.setup.id);
                this.cookieService.remove("REGISTRATION_SESS_UUID_" + this.sharedService.setup.id);

                this.cookieService.remove("attendeeId_CATALOG_" + this.sharedService.eventUUID);
                this.cookieService.remove("attendeeUUID_CATALOG_" + this.sharedService.eventUUID);
                this.cookieService.remove("REGISTRATION_SESS_UUID_CATALOG_" + this.sharedService.eventUUID);
                this.attendeeSessionService.getSessionApiOnLogin();
                this.messageService.sendMessage("attendee-logout");
            });
        }
    }

     loginWithSSO(ssoId) {
        let ssoProfile =
            "/svcs/catalog_sso/handleRequest/" +
            ssoId +
            "?catalogUUID=" + this.sharedService.setup.uuid +
            "&destination=login";
        jQuery("#ssoForm").attr("action", ssoProfile);
        jQuery("#ssoForm").submit();
    }

    showSideBar: boolean = false;
    toggleSideBar() {
        this.showSideBar = !this.showSideBar;
    }

    showCart: boolean = false;
    toggleCart() {
        if (!this.showCart) {
            this.sharedService.favData.size = 0;
            // this.sharedService.excData.size = 0;
            this.showCart = !this.showCart;
            this.sharedService.cartViewRender = true;
            this.sharedService.renderCartView();
        } else {
            this.showCart = !this.showCart;
            if (this.showCart == false) {
                this.sharedService.favData = {};
                this.sharedService.cartData = {};
            }
        }
    }
    showMySchedule: boolean = false;
    toggleMySchedule() {
        if (!this.showMySchedule) {
            this.messageService.sendMessage("update-my-schedule");
        } else {
            this.sharedService.showMyScheduleCalendar = false;
        }
        this.showMySchedule = !this.showMySchedule;
    }

    showSessionInstances: boolean = false;
    toggleSessionInstances(sessionId?) {
        if (!this.showSessionInstances && sessionId) {
            this.messageService.sendMessage("update-session-instances", sessionId);
        } else {
            this.messageService.sendMessage("update-session-instances");
        }
        this.showSessionInstances = !this.showSessionInstances;
    }

    clearAllFilter() {
        this.messageService.sendMessage("clear-all-filter");
    }

    clearSingleFilter(filterType, id) {
        this.messageService.sendMessage("clear-single-filter", { filterType: filterType, id: id });
    }

    showHtmlTop: boolean = true;
    toggleHtmlTop() {
        this.showHtmlTop = !this.showHtmlTop;
        this.messageService.sendMessage("toggle-html-top", this.showHtmlTop);
    }
}
